import { Button, ButtonProps, CircularProgress, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { extraColor } from '@styles/muiTheme';

interface ILoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingIndicator?: string;
  sx?: SxProps<Theme>;
  width?: string;
  children?: JSX.Element | JSX.Element[] | ReactNode;
}

interface IButtonProps extends ButtonProps {
    sx?: SxProps<Theme>;
    label?: string;
    width?: string;
    isLoading?: boolean;
}

export const SaveButton = ({
    type = 'submit',
    disabled = false,
    label = 'Save',
    width = '136px',
    isLoading = false,
    onClick,
    variant = 'contained',
    color = 'primary',
    sx = {
        marginRight: '5px',
        opacity: 0.97,
        backgroundColor: extraColor.palette.green.main,
        ':hover': {
            backgroundColor:  extraColor.palette.green.main,
            opacity: 1,
        }
    },
    ...props
}: IButtonProps) => {
    return (
        <LoadingButton
            type={type}
            disabled={disabled}
            loading={isLoading}
            color={color}
            variant={variant}
            sx={{ width, ...sx }}
            {...(onClick && { onClick: onClick })}
            {...props}
        >
            {label}
        </LoadingButton>
    );
};

export const CancelButton = ({
    disabled = false,
    label = 'Cancel',
    onClick,
    variant = 'outlined',
    color = 'error',
    width = '136px',
    sx = {marginRight: '5px'},
}: IButtonProps) => {
    return (
        <Button
            color={color}
            variant={variant}
            disabled={disabled}
            sx={{ width, ...sx }}
            {...(onClick && { onClick: onClick })}
        >
            {label}
        </Button>
    );
};

export const LoadingButton = ({
  disabled = false,
  loading = false,
  loadingIndicator = '',
  onClick,
  children,
  variant = 'outlined',
  color = 'primary',
  width = 'auto',
  sx,
  ...props
}: ILoadingButtonProps) => {
  return (
    <Button
      color={color}
      variant={variant}
      disabled={loading || disabled}
      sx={{ width, ...sx }}
      {...(onClick && { onClick: onClick })}
      {...props}
    >
      {loading ? (
        loadingIndicator ? (
          <>{loadingIndicator}</>
        ) : (
          <CircularProgress
            color="inherit"
            size={20}
          />
        )
      ) : (
        <>{children}</>
      )}
    </Button>
  );
};
